module.exports = __webpack_public_path__ + "static/media/37 - Sade - Smooth Operator (Single Version).42d4d90b.mp3";